import {getStowAssociates} from "../resources/StowResource";
import {publishCount, publishTime} from "../MetricUtility";
import {CYCLE, ERROR_METRIC_SUFFFIX} from "../constants";

export const LOAD_STOW_ASSOCIATES_CALL_BEGIN = "LOAD_STOW_ASSOCIATES_CALL_BEGIN"
export const LOAD_STOW_ASSOCIATES_CALL_SUCCESS = "LOAD_STOW_ASSOCIATES_CALL_SUCCESS";
export const LOAD_STOW_ASSOCIATES_CALL_FAILURE = "LOAD_STOW_ASSOCIATES_CALL_FAILURE";

const metricProcessName = "SCC_STOW_ASSOCIATE";

const loadStowAssociatesCallBegin = () => ({
    type: LOAD_STOW_ASSOCIATES_CALL_BEGIN,
});

const loadStowAssociatesCallSuccess = (associatesList) => ({
    type: LOAD_STOW_ASSOCIATES_CALL_SUCCESS,
    associatesList
});

const loadStowAssociatesCallFailure = () => ({
    type: LOAD_STOW_ASSOCIATES_CALL_FAILURE,
});

export const getStowAssociatesForAssociateView = (nodeId, cycles, CPTId, filterIdentifier,isCPTFilterEnabled) => {
    const metricName = "getStowAssociates";

    const request = {
        filters: {
            NODE: [nodeId],
        },
        fieldsRequired: ["NAME", "STATUS", "PERFORMANCE", "LOCATION"]
    };

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters[CYCLE] = cycles;
    }

    if (CPTId.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTId;
    }

    return async dispatch => {
        try {
            dispatch(loadStowAssociatesCallBegin());
            const startTime = Date.now();
            const associatesList = await getStowAssociates(request);
            if (associatesList) {
                dispatch(loadStowAssociatesCallSuccess(associatesList));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadStowAssociatesCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadStowAssociatesCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/AssociateActions.js